/**
 * Тип Telegram чата
 */
export type TelegramChatType = 'channel' | 'group' | 'supergroup';

/**
 * Telegram канал/чат
 */
export interface TelegramChannel {
  id: string;
  telegramId: string;
  title: string;
  isActive: boolean;
  /** Тип: канал, группа или супергруппа */
  type: TelegramChatType;
  /** Ссылка для отправки заявки на вступление (creates_join_request: true) */
  joinRequestLink?: string | null;
  // Metadata
  username?: string;
  description?: string;
  /** Total member count from Telegram */
  memberCount?: number;
  /** Active members from our subscription system */
  activeMemberCount?: number;
  photoUrl?: string;
  inviteLink?: string;
  lastSyncedAt?: string;
  /** Bot name that added this channel */
  botName?: string;
  createdAt: string;
  updatedAt: string;
}

/**
 * Данные формы создания/редактирования канала
 */
export interface TelegramChannelFormData {
  telegramId: string;
  title: string;
  isActive: boolean;
  type: TelegramChatType;
  joinRequestLink?: string | null;
}

/**
 * Метки для типов чатов
 */
export const CHAT_TYPE_LABELS: Record<TelegramChatType, string> = {
  channel: 'Канал',
  group: 'Группа',
  supergroup: 'Супергруппа',
};

/**
 * Опции для выбора типа чата
 */
export const CHAT_TYPE_OPTIONS: { value: TelegramChatType; label: string }[] = [
  { value: 'channel', label: 'Канал' },
  { value: 'group', label: 'Группа' },
  { value: 'supergroup', label: 'Супергруппа' },
];
